import booker from './booker.js';
import addOn from './addOn.js';
import promotion from './promotion.js';
export default {
    'es-mx': Object.assign({}, booker, addOn, promotion),
};
